import { useRef } from 'react'

import { useOutsideClick } from '@sequencehq/utils'
import {
  Text,
  IconXMark,
  Button,
  GreyGrey60,
  GreyGrey80,
  Primary13SemiBold,
  TextInputField,
  Flex
} from '@sequencehq/core-components'
import { usePopoverPublishedQuote } from './usePopoverPublishedQuote'

type Props = {
  onClose: () => void
}

export const PopoverPublishedQuote = ({ onClose }: Props) => {
  const refWrapper = useRef<HTMLDivElement | null>(null)
  useOutsideClick({ ref: refWrapper, handler: () => onClose() })

  const { linkUrl, buttonCopy, buttonClose } = usePopoverPublishedQuote({
    onClose
  })

  return (
    <Flex
      ref={refWrapper}
      data-testid="quote.publishedLinkPopover"
      flexDirection="column"
      padding="12px"
      width="347px"
      gap="8px"
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Text {...Primary13SemiBold} color={GreyGrey80}>
          Published quote
        </Text>

        <Button variant="unstyled" size="20px" onClick={buttonClose.onClick}>
          <IconXMark color={GreyGrey80} />
        </Button>
      </Flex>

      <Flex gap="8px">
        <TextInputField
          value={linkUrl}
          readOnly
          style={{ color: GreyGrey60, textOverflow: 'ellipsis' }}
        />
        <Button variant="primary" onClick={buttonCopy.onClick}>
          {buttonCopy.text}
        </Button>
      </Flex>
    </Flex>
  )
}
